<div class="row nested-row references">
  <div class="col-12">
    <span class="bold">Related References:</span>
    <ul class="list-inline d-inline-block ml-3 mb-0">
      <li class="list-inline-item mb-2" *ngFor="let item of references">
        <a *ngIf="item.referencedId" class="pill-reference"
           [routerLink]="['/' +
           (item.referencedType === 'INDICATION' ? 'indications' :
           (item.referencedType === 'CONFERENCE' ? 'conferences' : item.referencedType.toLowerCase()))
           , item.referencedId]"
           target="_blank">
          <span class="bold">{{item.referencedType}}</span>
          {{item.referencedLabel}}
        </a>

        <span *ngIf="!item.referencedId" class="pill-reference no-landing">
          <span class="bold">{{item.referencedType}}</span>
          {{item.referencedLabel}}
        </span>

      </li>
    </ul>
  </div>
</div>
<rms-reference-modal [entity]="entity"></rms-reference-modal>
